// JS COMPONENTS ---------------------------------------------------------------
import NavAllCategories from './navAllCategories/navAllCategories.js';
import SidebarMenu from './sidebarMenu/sidebarMenu.js';
import GoTop from './goTop/goTop.js';
import ScrollTo from './scrollTo/scrollTo.js';
import PageMain from './pageMain/pageMain.js';
import ScalableElement from './scalableElement/scalableElement.js';
import AccountSingleOrder from './accountSingleOrder/accountSingleOrder.js';
import Address from './address/address.js';
// autoImportJsPlaceholder
// VUE COMPONENTES -------------------------------------------------------------
import PageOverlay from './pageOverlay/pageOverlay.vue';
import HeaderVue from './headerVue/headerVue.vue';
import HeaderMetaContent from './headerMetaContent/headerMetaContent.vue';
import UserShortcut from './userShortcut/userShortcut.vue';
import Input from './inputVue/inputVue.vue';
import Checkbox from './checkbox/checkbox.vue';
import Breadcrumbs from "./breadcrumbs/breadcrumbs";
import CookieBox from './cookieBox/cookieBox.vue'
import CookieDisclaimer from "./cookieDisclaimer/cookieDisclaimer";
import SuccessLogout from "./successLogout/successLogout";
import BurgerMenu from './burgerMenu/burgerMenu.vue';
import BurgerNavTree from './burgerNavTree/burgerNavTree.vue';
import ImageMagnify from './imageMagnify/imageMagnify.vue';
import Loader from './loader/loader.vue';
import Captcha from './captcha/captcha.vue';
import SearchAutosuggest from './searchAutosuggest/searchAutosuggest.vue';
import Filter from './filter/filter.vue';
import FilterPrice from './filterPrice/filterPrice.vue';
import FilterRating from './filterRating/filterRating';
import RangeSlider from './rangeSlider/rangeSlider.vue';
import ProductBox from './productBox/productBox.vue';
import ProductsList from './productsList/productsList.vue';
import ProductsSort from './productsSort/productsSort.vue';
import ActiveFilters from './activeFilters/activeFilters.vue';
import FilterCategory from './filterCategory/filterCategory.vue';
import Modal from './modal/modal.vue';
import GlobalAppError from './globalAppError/globalAppError.vue';
import Counter from './counter/counter.vue';
// import CartQuantityEdit from './cartQuantityEdit/cartQuantityEdit.vue';
import CsrfInput from './csrfInput/csrfInput.vue';
import SaleBox from './saleBox/saleBox.vue';
import ProductGallery from './productGallery/productGallery.vue';
import Minicart from './minicart/minicart.vue';
import ProductVariations from './productVariations/productVariations.vue';
import ProductGraduatedPrices from './productGraduatedPrices/productGraduatedPrices.vue';
import RadioInputsList from './radioInputsList/radioInputsList.vue';
import RadioInputsPayment from './radioInputsPayment/radioInputsPayment.vue';
import EditProduct from './editProduct/editProduct.vue';
import HeroSlider from './heroSlider/heroSlider.vue';
import Carousel from './carousel/carousel.vue';
import VueComponentCloner from './vueComponentCloner/vueComponentCloner.vue';
import ProductFeatures from './productFeatures/productFeatures.vue';
// import SingleOrderDetails from './singleOrderDetails/singleOrderDetails.vue';
import GeneralMessage from './generalMessage/generalMessage.vue';
import PhotoSwipeGallery from './photoSwipeGallery/photoSwipeGallery.vue';
import HeadlineTeaser from './headlineTeaser/headlineTeaser.vue';
import RecommendationsTeaser from './recommendationsTeaser/recommendationsTeaser.vue';
import ImageTeaser from './imageTeaser/imageTeaser.vue';
import HalfSizeTeaser from './halfSizeTeaser/halfSizeTeaser.vue';
import ServiceTeaser from './serviceTeaser/serviceTeaser.vue';
import ServicesListTeaser from './servicesListTeaser/servicesListTeaser.vue';
import ImageTeasersSet from './imageTeasersSet/imageTeasersSet.vue';
import SimpleImageTeaser from './simpleImageTeaser/simpleImageTeaser.vue';
import BoxInsertionTeaser from './boxInsertionTeaser/boxInsertionTeaser.vue';
import BoxInsetionTeaserItem from './boxInsertionTeaserItem/boxInsertionTeaserItem.vue';
import CategoryOverviewTeaser from './categoryOverviewTeaser/categoryOverviewTeaser.vue';
import CategoryOverviewTeaserWrapper from './categoryOverviewTeaser/categoryOverviewTeaserWrapper.vue';
import ProductGridTeaser from './productGridTeaser/productGridTeaser.vue';
import HtmlTeaser from './htmlTeaser/htmlTeaser.vue';
import BrandTile from './brandTile/brandTile.vue';
import BrandsTilesTeaser from './brandsTilesTeaser/brandsTilesTeaser.vue';
import BrandsTeaser from './brandsTeaser/brandsTeaser.vue';
import Accordion from './accordion/accordion.vue';
import AccordionsList from './accordionsList/accordionsList.vue';
import FooterTeaser from './footerTeaser/footerTeaser.vue';
import KartonSuche from './kartonSucheTeaser/kartonSucheTeaser.vue';
import ConfiguratorTeaser from './configuratorTeaser/configuratorTeaser.vue';
import HalfFullSizeWrapper from './halfFullSizeTeaser/halfFullSizeWrapper.vue';
import HalfFullSizeTeaser from './halfFullSizeTeaser/halfFullSizeTeaser.vue';
import NewsletterTeaser from './newsletterTeaser/newsletterTeaser.vue';
import ProductDetailedPage from './productDetailedPage/productDetailedPage.vue';
import ProductDescription from './productDescription/productDescription.vue';
import ProductAdditionalInformation from './productAdditionalInformation/productAdditionalInformation.vue';
import ProductFlags from './productFlags/productFlags.vue';
import ProductPagePagination from './productPagePagination/productPagePagination.vue';
import ProductNavigation from './productNavigation/productNavigation.vue';
import ProductPageBrand from './productPageBrand/productPageBrand.vue';
import LaterAvailableReminder from './laterAvailableReminder/laterAvailableReminder.vue';
import Navigation from './navigation/navigation.vue';
import NavigationFlyout from './navigationFlyout/navigationFlyout.vue';
import CheckoutProcessBreadcrumbs from './checkoutProcessBreadcrumbs/checkoutProcessBreadcrumbs.vue';
import Footer from './footer/footer.vue';
import ImageAssetList from './imageAssetList/imageAssetList.vue';
import SocialMedia from './socialMedia/socialMedia.vue';
import ServiceLinks from './serviceLinks/serviceLinks.vue';
import ContactForm from './contactForm/contactForm.vue';
import Filters from './filters/filters.vue';
import ProductsListPage from './productsListPage/productsListPage.vue';
import ProductItemsTable from "./productItemsTable/ProductItemsTable.vue";
import ProductSafetyInformationAccordion from "./productSafetyInformationAccordion/ProductSafetyInformationAccordion.vue";
import StringList from "./stringList/stringList.vue";
// import CartPage from './cartPage/cartPage.vue';
// import ProductsOrderTable from './productsOrderTable/productsOrderTable.vue';
// import ProductOrderPosition from './productOrderPosition/productOrderPosition.vue';
// import PromoItemsList from './promoItemsList/promoItemsList.vue';
// import PromoItem from './promoItem/promoItem.vue';
// import OrderSummary from './orderSummary/orderSummary.vue';
import TemplateCompiler from './templateCompiler/templateCompiler.vue';
import ReCaptcha from './reCaptcha/reCaptcha.vue';
import CheckoutStepConfirmation from './checkoutStepConfirmation/checkoutStepConfirmation.vue';
import CheckoutStepPayment from './checkoutStepPayment/checkoutStepPayment.vue';
import ContactInfo from "./contactInfo/contactInfo.vue";
import PrintModal from "./printModal/printModal";
import ImageDropzone from "./imageDropzone/ImageDropzone";
import { defineAsyncComponent } from "vue";
// autoImportVuePlaceholder

const JsComponents = [
  { name: 'nav-all-categories', constructor: NavAllCategories },
  { name: 'sidebar-menu', constructor: SidebarMenu },
  { name: 'go-top', constructor: GoTop },
  { name: 'scroll-to', constructor: ScrollTo },
  { name: 'page-main', constructor: PageMain },
  { name: 'scalable-element', constructor: ScalableElement },
  { name: 'account-single-order', constructor: AccountSingleOrder },
  { name: 'address', constructor: Address },
  // autoRegisterJsPlaceholder
];

const VueComponents = [
  { name: 'page-overlay', constructor: PageOverlay },
  { name: 'header-vue', constructor: HeaderVue },
  { name: 'header-meta-content', constructor: HeaderMetaContent },
  { name: 'user-shortcut', constructor: UserShortcut },
  { name: 'input-vue', constructor: Input },
  { name: 'checkbox', constructor: Checkbox },
  { name: 'cookie-box', constructor: CookieBox },
  { name: 'cookie-disclaimer', constructor: CookieDisclaimer },
  { name: 'success-logout', constructor: SuccessLogout },
  { name: 'contact-info', constructor: ContactInfo },
  { name: 'loader', constructor: Loader },
  { name: 'burger-menu', constructor: BurgerMenu },
  { name: 'burger-nav-tree', constructor: BurgerNavTree },
  { name: 'image-magnify', constructor: ImageMagnify },
  { name: 'captcha', constructor: Captcha },
  { name: 'search-autosuggest', constructor: SearchAutosuggest },
  { name: 'filter-vue', constructor: Filter },
  { name: 'filter-price', constructor: FilterPrice },
  { name: 'filter-rating', constructor: FilterRating },
  { name: 'range-slider', constructor: RangeSlider },
  { name: 'product-box', constructor: ProductBox },
  { name: 'products-list', constructor: ProductsList },
  { name: 'products-sort', constructor: ProductsSort },
  { name: 'pagination', constructor: defineAsyncComponent(() => import( './pagination/pagination.vue')) },
  { name: 'active-filters', constructor: ActiveFilters },
  { name: 'filter-category', constructor: FilterCategory },
  { name: 'filters', constructor: Filters },
  { name: 'products-list-page', constructor: ProductsListPage },
  {
    name: 'pagination-order-history',
    constructor: defineAsyncComponent(() => import(/*webpackChunkName: 'checkoutAndAccount'*/ './paginationOrderHistory/paginationOrderHistory.vue'))
  },
  { name: 'global-app-error', constructor: GlobalAppError },
  { name: 'counter', constructor: Counter },
  {
    name: 'cart-quantity-edit',
    constructor: defineAsyncComponent(() => import(/*webpackChunkName: 'checkoutAndAccount'*/ './cartQuantityEdit/cartQuantityEdit.vue'))
  },
  { name: 'csrf-input', constructor: CsrfInput },
  { name: 'sale-box', constructor: SaleBox },
  { name: 'product-gallery', constructor: ProductGallery },
  { name: 'minicart', constructor: Minicart },
  { name: 'product-variations', constructor: ProductVariations },
  { name: 'product-graduated-prices', constructor: ProductGraduatedPrices },
  { name: 'radio-inputs-list', constructor: RadioInputsList },
  { name: 'radio-inputs-payment', constructor: RadioInputsPayment },
  { name: 'edit-product', constructor: EditProduct },
  { name: 'modal', constructor: Modal },
  { name: 'hero-slider', constructor: HeroSlider },
  { name: 'karton-suche-teaser', constructor: KartonSuche },
  { name: 'carousel', constructor: Carousel },
  { name: 'vue-component-cloner', constructor: VueComponentCloner },
  { name: 'product-features', constructor: ProductFeatures },
  {
    name: 'single-order-details',
    constructor: defineAsyncComponent(() => import(/*webpackChunkName: 'checkoutAndAccount'*/ './singleOrderDetails/singleOrderDetails.vue'))
  },
  { name: 'general-message', constructor: GeneralMessage },
  { name: 'photo-swipe-gallery', constructor: PhotoSwipeGallery },
  { name: 'headline-teaser', constructor: HeadlineTeaser },
  { name: 'recommendations-teaser', constructor: RecommendationsTeaser },
  { name: 'image-teaser', constructor: ImageTeaser },
  { name: 'product-description', constructor: ProductDescription },
  { name: 'product-additional-information', constructor: ProductAdditionalInformation },
  { name: 'half-size-teaser', constructor: HalfSizeTeaser },
  { name: 'service-teaser', constructor: ServiceTeaser },
  { name: 'services-list-teaser', constructor: ServicesListTeaser },
  { name: 'image-teasers-set', constructor: ImageTeasersSet },
  { name: 'simple-image-teaser', constructor: SimpleImageTeaser },
  { name: 'box-insertion-teaser', constructor: BoxInsertionTeaser },
  { name: 'category-overview-teaser', constructor: CategoryOverviewTeaser },
  { name: 'category-overview-teaser-wrapper', constructor: CategoryOverviewTeaserWrapper },
  { name: 'product-grid-teaser', constructor: ProductGridTeaser },
  { name: 'box-insertion-teaser-item', constructor: BoxInsetionTeaserItem },
  { name: 'html-teaser', constructor: HtmlTeaser },
  { name: 'brand-tile', constructor: BrandTile },
  { name: 'brands-tiles-teaser', constructor: BrandsTilesTeaser },
  { name: 'brands-teaser', constructor: BrandsTeaser },
  { name: 'accordion', constructor: Accordion },
  { name: 'accordions-list', constructor: AccordionsList },
  { name: 'footer-teaser', constructor: FooterTeaser },
  { name: 'product-flags', constructor: ProductFlags },
  { name: 'product-navigation', constructor: ProductNavigation },
  { name: 'product-page-pagination', constructor: ProductPagePagination },
  { name: 'product-page-brand', constructor: ProductPageBrand },
  { name: 'navigation', constructor: Navigation },
  { name: 'navigation-flyout', constructor: NavigationFlyout },
  { name: 'breadcrumbs', constructor: Breadcrumbs },
  { name: 'footer-vue', constructor: Footer },
  { name: 'image-asset-list', constructor: ImageAssetList },
  { name: 'social-media', constructor: SocialMedia },
  { name: 'checkout-process-breadcrumbs', constructor: CheckoutProcessBreadcrumbs },
  { name: 'product-detailed-page', constructor: ProductDetailedPage },
  {
    name: 'cart-page',
    constructor: defineAsyncComponent(() => import(/*webpackChunkName: 'checkoutAndAccount'*/ './cartPage/cartPage.vue'))
  },
  {
    name: 'send-basket-form',
    constructor: defineAsyncComponent(() => import(/*webpackChunkName: 'checkoutAndAccount'*/ './sendBasketForm/sendBasketForm.vue'))
  },
  {
    name: 'products-order-table',
    constructor: defineAsyncComponent(() => import(/*webpackChunkName: 'checkoutAndAccount'*/ './productsOrderTable/productsOrderTable.vue'))
  },
  {
    name: 'product-order-position',
    constructor: defineAsyncComponent(() => import(/*webpackChunkName: 'checkoutAndAccount'*/ './productOrderPosition/productOrderPosition.vue'))
  },
  {
    name: 'configurator-order-position',
    constructor: defineAsyncComponent(() => import(/*webpackChunkName: 'checkoutAndAccount'*/ './configuratorOrderPosition/configuratorOrderPosition'))
  },
  {
    name: 'promo-items-list',
    constructor: defineAsyncComponent(() => import(/*webpackChunkName: 'checkoutAndAccount'*/ './promoItemsList/promoItemsList.vue'))
  },
  {
    name: 'promo-item',
    constructor: defineAsyncComponent(() => import(/*webpackChunkName: 'checkoutAndAccount'*/ './promoItem/promoItem.vue'))
  },
  {
    name: 'order-summary',
    constructor: defineAsyncComponent(() => import(/*webpackChunkName: 'checkoutAndAccount'*/ './orderSummary/orderSummary.vue'))
  },
  {
    name: 'checkout-step-summary-payment-information',
    constructor: defineAsyncComponent(() => import(/*webpackChunkName: 'checkoutAndAccount'*/ './checkoutStepSummary/checkoutStepSummaryPaymentInformation.vue'))
  },
  {
    name: 'checkout-step-summary-palette-information',
    constructor: defineAsyncComponent(() => import(/*webpackChunkName: 'checkoutAndAccount'*/ './checkoutStepSummary/checkoutStepSummaryPaletteInformation.vue'))
  },
  {
    name: 'register-email-form',
    constructor: defineAsyncComponent(() => import(/* webpackChunkName: 'checkoutAndAccount' */ './registerEmailForm/registerEmailForm.vue'))
  },
  {
    name: 'register-form',
    constructor: defineAsyncComponent(() => import(/* webpackChunkName: 'checkoutAndAccount' */ './registerForm/registerForm.vue'))
  },
  {
    name: 'login-form',
    constructor: defineAsyncComponent(() => import(/* webpackChunkName: 'checkoutAndAccount' */ './loginForm/loginForm.vue'))
  },
  {
    name: 'address-form',
    constructor: defineAsyncComponent(() => import(/* webpackChunkName: 'checkoutAndAccount' */ './addressForm/addressForm.vue'))
  },
  {
    name: 'billing-address-form',
    constructor: defineAsyncComponent(() => import(/* webpackChunkName: 'checkoutAndAccount' */ './billingAddressForm/billingAddressForm.vue'))
  },
  {
    name: 'credit-card',
    constructor: defineAsyncComponent(() => import(/* webpackChunkName: 'checkoutAndAccount' */ './creditCard/creditCard.vue'))
  },
  {
    name: 'account-address-form',
    constructor: defineAsyncComponent(() => import(/* webpackChunkName: 'checkoutAndAccount' */ './accountAddressForm/accountAddressForm.vue'))
  },
  {
    name: 'account-billing-address-form',
    constructor: defineAsyncComponent(() => import(/* webpackChunkName: 'checkoutAndAccount' */ './accountBillingAddressForm/accountBillingAddressForm.vue'))
  },
  { name: 'later-available-reminder', constructor: LaterAvailableReminder },
  {
    name: 'password-reset-request-form',
    constructor: defineAsyncComponent(() => import(/* webpackChunkName: 'checkoutAndAccount' */ './passwordResetRequestForm/passwordResetRequestForm.vue'))
  },
  { name: 'contact-form', constructor: ContactForm },
  {
    name: 'password-form',
    constructor: defineAsyncComponent(() => import(/* webpackChunkName: 'checkoutAndAccount' */ './passwordForm/passwordForm.vue'))
  },
  {
    name: 'promo-code-form',
    constructor: defineAsyncComponent(() => import(/* webpackChunkName: 'checkoutAndAccount' */ './promoCodeForm/promoCodeForm.vue'))
  },
  {
    name: 'product-history-article',
    constructor: defineAsyncComponent(() => import(/* webpackChunkName: 'checkoutAndAccount' */ './accountProductHistory/productHistoryArticle.vue'))
  },
  {
    name: 'account-password-form',
    constructor: defineAsyncComponent(() => import(/* webpackChunkName: 'checkoutAndAccount' */ './accountPasswordView/accountPasswordForm.vue'))
  },
  { name: 'service-links', constructor: ServiceLinks },
  { name: 'template-compiler', constructor: TemplateCompiler },
  { name: 're-captcha', constructor: ReCaptcha },
  { name: 'checkout-step-confirmation', constructor: CheckoutStepConfirmation },
  { name: 'checkout-step-payment', constructor: CheckoutStepPayment },
  { name: 'configurator-teaser', constructor: ConfiguratorTeaser },
  { name: 'half-full-size-teaser-wrapper', constructor: HalfFullSizeWrapper },
  { name: 'half-full-size-teaser', constructor: HalfFullSizeTeaser },
  { name: 'newsletter-teaser', constructor: NewsletterTeaser },
  { name: 'print-modal', constructor: PrintModal },
  { name: 'image-dropzone', constructor: ImageDropzone },
  { name: 'product-items-table', constructor: ProductItemsTable },
  { name: 'product-safety-information', constructor: ProductSafetyInformationAccordion },
  { name: 'string-list', constructor: StringList },
  // autoRegisterVuePlaceholder
];

export { JsComponents, VueComponents };
